import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const ChallengeScreen: React.FC = () => {
  const { theme } = useTheme();

  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: theme.colors.background,
      padding: theme.spacing.md,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    content: {
      textAlign: 'center' as const,
    },
    title: {
      fontSize: theme.typography.h1.fontSize,
      fontWeight: theme.typography.h1.fontWeight,
      color: theme.colors.text,
      marginBottom: theme.spacing.md,
    },
    subtitle: {
      fontSize: theme.typography.body.fontSize,
      color: theme.colors.textSecondary,
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.title}>Challenge Details</h1>
        <p style={styles.subtitle}>Challenge screen coming soon...</p>
      </div>
    </div>
  );
};

export default ChallengeScreen; 